<template>
	<div>
		<titlecom :title="welcome"></titlecom>
		<div class="line"></div>
		<div style="padding-left:20px ;">
			<p>
				<br />
			</p>
			<p class="MsoNormal">
				<span style="font-size:16px;"><strong><span style="color:rgb(20, 90, 245);">地点：</span></strong><span style="color:#666666;">上海跨国采购会展中心</span></span><br />

			</p>
			<p>
				<span style="font-size:16px;"><span style="color:rgb(20, 90, 245);"><strong>地址：</strong></span><span style="color:#666666;">上海市普陀区光复西路
						2739 号</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">会场入口请从上海跨国采购会展中心-南一门入（光复西路中江路口）</span></strong>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">地铁线路</span></strong>
			</p>
			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">地铁 15 号线</span></strong>：地铁15号线
				长风公园站 3号口出（距离会场约730米）</span><br />


			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">地铁 2 号线</span></strong>：<span
					 style="color:#666666;">威宁路站4号口出（距离会场约1.3公里）</span></span>
			</p>

			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">地铁 13 号线</span></strong>：<span
					 style="color:#666666;">大渡河路站3号口出（距离会场约1.7公里）</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">公交线路</span></strong>
			</p>
			<p>
				<br />
			</p>
			<p><span style="font-size:16px;color:#666666;">云岭东路：44、551 等</span><br /></p>
			<p><span style="font-size:16px;color:#666666;">大渡河路：141、长征 2 路等</span><br /></p>
			<p><span style="font-size:16px;color:#666666;">古北路：316、54、944、757 等</span><br /></p>

			<p>
				<span style="color:#666666;">天山西路：71、72、74、141、311、808、251、825、829、856、941、944、190等</span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">驾车线路</span></strong>
			</p>
			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;">延安路高架娄山关路匝道口下，于娄山关路右转，直行至天山西路左转，到古北路右转，上古北路桥，下桥后光复西路左转，直行至中江路即可到达；</span><br />

			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;">内环高架金沙江路匝道口下，沿金沙江路直行，到大渡河路左转，至云岭东路右转，到中江路左转即可到达；</span>
			<br />

			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><span style="color:#666666;">中环线金沙江路口下，沿金沙江路直行，至中江路右转即可到达；</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<strong><span style="color:rgb(20, 90, 245);">周边环境</span>&nbsp;</strong>
			</p>
			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">机场：</span></strong><span style="color:#666666;">离虹桥机场
						1 号航站楼 8.8 公里，2 号航站楼 11 公里</span></span>
			</p>
			<p>
				<br />
			</p>
			<p>
				<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">火车站：</span></strong><span style="color:#666666;">离虹桥火车站
						13 公里</span></span>
			</p>
			<p>
				<br />
			</p>
			<span style="font-size:16px;color:#666666;"><strong><span style="color:#000000;">周围地标：</span></strong>上海新发展亚太万豪酒店、成龙电影艺术馆、2
				号绿地游艇码头、国盛时尚绿色购物中心、长风公园等</span><br />

			<img src="../../../assets/zlan.png" style="width: 100%;margin-top: 30px;" />
			<img src="../../../assets/zusu.png" style="width: 100%;margin-top: 30px;" />
			<p><strong>
					<a href="http://bisc2021.fumed.com.cn/hotel">
						<p style="font-size: 12px;color: #000000;margin-left: 24px;">点击以下链接预定住宿</p>
					</a>
				</strong> </p>
		</div>
	</div>
</template>

<script>
	import titlecom from '@/components/title/title.vue'
	export default {
		data() {
			return {
				welcome: '会议指南'
			}
		},
		components: {
			titlecom
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				this.$router.push({
					path: '/guide-phone'
				})
			}

		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';

	p {
		margin: 10px 0;

	}
</style>
